// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3f-WL","tab":"ProcedureTabs_tab__R_KYh"};